export const enum EGuideStatus {
    READY_FOR_PICKUP = 'READY_FOR_PICKUP',
    ACCEPTED = 'ACCEPTED',
    ARRIVED_AT_PICKUP = 'ARRIVED_AT_PICKUP',
    WAY_TO_DELIVER = 'WAY_TO_DELIVER',
    COMPLETED = 'COMPLETED',
}
